var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRedDoc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_49643",
    "data-name": "Path 49643",
    d: "M19.18,7.132,14.974,2.826a2.864,2.864,0,0,0-2.051-.82H6.872A2.78,2.78,0,0,0,4,4.774V19.129A2.866,2.866,0,0,0,6.872,22H17.128A2.866,2.866,0,0,0,20,19.129V9.081a2.8,2.8,0,0,0-.82-1.948ZM8.923,10.106H12a.809.809,0,0,1,.821.82.755.755,0,0,1-.821.82H8.923a.82.82,0,1,1,0-1.641Zm6.154,5.742H8.923a.809.809,0,0,1-.821-.82.755.755,0,0,1,.821-.82h6.154a.82.82,0,1,1,0,1.641Z",
    transform: "translate(-4 -2)",
    fill: "#fe5a3e"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedDoc);
export default __webpack_public_path__ + "static/media/redDoc.41322760848c995a24782faeaff0c5af.svg";
export { ForwardRef as ReactComponent };